import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getSource, isGifDeviation, isVideoDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
function getMediaType(deviation) {
    if (isVideoDeviation(deviation)) {
        return 'video';
    }
    if (isGifDeviation(deviation)) {
        return 'gif';
    }
}
function getDuration(deviation) {
    var videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    return videoFile === null || videoFile === void 0 ? void 0 : videoFile.duration;
}
function getIndicators(deviation) {
    var indicators = [];
    if (deviation.primaryTier) {
        indicators.push('in-tier');
    }
    var _a = normalizePremiumFolderData(deviation.premiumFolderData), isWatchToAccess = _a.isWatchToAccess, isPaidFolder = _a.isPaidFolder;
    if (isPaidFolder) {
        indicators.push('in-premium');
    }
    if (isWatchToAccess) {
        indicators.push('in-watchers-only');
    }
    // TODO: add PCP if/when they want it
    // TODO: add NFT when relevant
    return indicators;
}
var DeviationThumbOverlayDefault = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, isFaved = _a.isFaved, hasCommentedOn = _a.hasCommentedOn, children = _a.children, className = _a.className;
    var blockType = useDeviationBlockType(deviation);
    var _b = useOverlayContext(deviation), showPermanentEngagementIcon = _b.showPermanentEngagementIcon, showDailyDeviationLabel = _b.showDailyDeviationLabel, showMediaIndicators = _b.showMediaIndicators, showThumbStatusIndicators = _b.showThumbStatusIndicators;
    return (React.createElement(ThumbOverlayDefault, { width: width, height: height, isDailyDeviation: showDailyDeviationLabel && deviation.isDailyDeviation, isFaved: showPermanentEngagementIcon && isFaved, isCommented: showPermanentEngagementIcon && hasCommentedOn, statusIndicators: showThumbStatusIndicators && !blockType
            ? getIndicators(deviation)
            : undefined, mediaIndicator: showMediaIndicators && !blockType ? getMediaType(deviation) : undefined, duration: getDuration(deviation), className: className }, children));
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';
export default DeviationThumbOverlayDefault;
//# sourceMappingURL=DeviationThumbOverlayDefault.js.map